import { render, staticRenderFns } from "./approval_button_multi.vue?vue&type=template&id=bd85376e&scoped=true"
import script from "./approval_button_multi.vue?vue&type=script&lang=js"
export * from "./approval_button_multi.vue?vue&type=script&lang=js"
import style0 from "./approval_button_multi.vue?vue&type=style&index=0&id=bd85376e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd85376e",
  null
  
)

export default component.exports